import Vue from 'vue';
/**
 * Content components
 */
import NotFound404Component from './content/404-component';
import TemplateLoader from './template-loader';

import TitleNavbarComponent from './common/title-navbar';
/**
 * shared components
 */
import InlineMessageComponent from './shared/inline-message-component';
import ModalMessageComponent from './shared/modal-message-component';
import FloatMessageComponent from './shared/float-message-component';
import Fragment from './shared/utilities/Fragment';
import Notifications from './widgets/betslip/components/shared/notifications-result';
/**
 * Widget components
 */
import RowComponent from './widgets-builder/row-component';
import ColComponent from './widgets-builder/col-component';
import ColWidgetComponent from './widgets-builder/col-widget-component';
import QuickLinksWidget from './widgets/quick-links/quick-links-widget';
import MyFavoritesWidget from './widgets/my-favorites/widget-my-favorites';
import LastMinuteBetsWidget from './widgets/last-minute-bets/last-minute-bets-widget';
import FixtureMenuWidget from './widgets/fixture-menu/widget-fixture-menu';
import MainNavWidget from './widgets/main-nav/widget-main-nav';
import BetslipCheckerWidget from './widgets/betslip-checker/widget-betslip-checker';
import BetButtonsWidget from './widgets/bet-buttons/bet-buttons-widget';
import ImageBannerWidget from './widgets/image-banner/image-banner-widget';
import TopWinningsWidget from './widgets/top-winnings/widget-top-winnings';
import BetsForYouWidget from './widgets/bets-for-you/bets-for-you-widget';
import BettingMenuWidget from './widgets/betting-menu/widget-betting-menu';
import ContentSliderWidget from './widgets/content-slider/widget-content-slider';
import MatchCodeWidget from './widgets/match-code/widget-match-code';
import RouterWidget from './widgets/router/router-widget';
import BetSearchWidget from './widgets/bet-search/bet-search-widget';
import LiveNowWidget from './widgets/live-now/live-now-widget';
import HorseRacingWidget from './widgets/horse-racing/widget-horse-racing';
import ScheduleRacesWidgetHr from './widgets/schedule-widget-hr/widget-schedule-races';
import HighlightsWidget from './widgets/highlights/widget-highlights';
import UpcomingWidget from './widgets/upcoming/widget-upcoming';
import LiveFixtureMenuWidget from './widgets/live-fixture-menu/widget-live-fixture-menu';
import UpcomingFixtureMenuWidget from './widgets/upcoming-fixture-menu/widget-upcoming-fixture-menu';
import EventViewWidget from './widgets/event-view/widget-event-view';
import LiveChannelOnlineWidget from './widgets/live-channel-online/widget-live-channel-online';
import LiveFavoritesWidget from './widgets/live-favorites/widget-live-favorites';
import QuickLinksHorizontalWidget from './widgets/quick-links-horizontal';
import ColCopyWidget from './widgets/col-copy-widget';
import NetbotsRobotipWidget from '../components/widgets/netbots-robotip/widget-netbots-robotip';
import BetBuilderFixture from './widgets/betbuilder-fixture';
import VideoStreamingWidget from './widgets/live-channel-online/widget-video-streaming';
import BoostedOddWidget from '@bto-widgets/boosted-odd/web';
import TopEventsWidget from '@bto-widgets/top-events/web';
import CombinedSliderWidget from '@bto-widgets/combined-slider/web';
import FavoriteCategoriesWidget from './widgets/favorite-category-list/widget-my-fav-categories';
import DatePicker from '../vue2-datepicker.min';
import Vuebar from 'vuebar';
import { LogoComponent } from '@bto-widgets/utils/shared'

Vue.use(Vuebar);
Vue.component('LogoComponent', LogoComponent);
Vue.component('date-picker', DatePicker);

Vue.component('row-component', RowComponent);
Vue.component('netbots-robotip-widget', NetbotsRobotipWidget);
Vue.component('col-component', ColComponent);
Vue.component('col-widget-component', ColWidgetComponent);
Vue.component('quick-links-widget', QuickLinksWidget);
Vue.component('my-favorites-widget', MyFavoritesWidget);
Vue.component('last-minute-bets-widget', LastMinuteBetsWidget);
Vue.component('fixture-menu-widget', FixtureMenuWidget);
Vue.component('main-nav-widget', MainNavWidget);
Vue.component('betslip-checker-widget', BetslipCheckerWidget);
Vue.component('bet-buttons-widget', BetButtonsWidget);
Vue.component('image-banner-widget', ImageBannerWidget);
Vue.component('top-winnings-widget', TopWinningsWidget);
Vue.component('bets-for-you-widget', BetsForYouWidget);
Vue.component('betting-menu-widget', BettingMenuWidget);
Vue.component('content-slider-widget', ContentSliderWidget);
Vue.component('match-code-widget', MatchCodeWidget);
Vue.component('router-widget', RouterWidget);
Vue.component('bet-search-widget', BetSearchWidget);
Vue.component('live-now-widget', LiveNowWidget);
Vue.component('highlights-widget', HighlightsWidget);
Vue.component('upcoming-widget', UpcomingWidget);
Vue.component('live-favorites-widget', LiveFavoritesWidget);
Vue.component('live-fixture-menu-widget', LiveFixtureMenuWidget);
Vue.component('upcoming-fixture-menu-widget', UpcomingFixtureMenuWidget);
Vue.component('event-view-widget', EventViewWidget);
Vue.component('live-channel-online-widget', LiveChannelOnlineWidget);
Vue.component('quick-links-horizontal-widget', QuickLinksHorizontalWidget);
Vue.component('col-copy-widget', ColCopyWidget);
Vue.component('horse-racing-widget', HorseRacingWidget);
Vue.component('schedule-races-widget-hr', ScheduleRacesWidgetHr);
Vue.component('bet-builder-fixture', BetBuilderFixture);
Vue.component('video-streaming-widget', VideoStreamingWidget);
Vue.component('boosted-odd-widget', BoostedOddWidget);
Vue.component('top-events-widget', TopEventsWidget);
Vue.component('combined-slider-widget', CombinedSliderWidget);
Vue.component('favorite-categories-widget', FavoriteCategoriesWidget);

/**
 * Content components
 */
Vue.component('notfound-404', NotFound404Component);
Vue.component('template-loader', TemplateLoader);

/**
 * comon components
 */
Vue.component('inline-message', InlineMessageComponent);
Vue.component('modal-message', ModalMessageComponent);
Vue.component('float-message', FloatMessageComponent);
// eslint-disable-next-line
Vue.component('Fragment', Fragment);
Vue.component('notification-result', Notifications);
Vue.component('title-navbar', TitleNavbarComponent);
